import type { Pead } from "epsm-api-types/models";
import { formatValuePercent } from "@/components/widgets/helpers/FormattingHelpers";
import { NO_DATA } from "../../../consts";

export function getActualDataForHistory(data: Pead) {
	return formatValuePercent(data.actual, NO_DATA);
}
